import RelatedActivityCollection from 'collections/related_activity';
import ActivityLog from 'models/activity_log';


export default RelatedActivityCollection.extend({
  date: null, // if set, restricts the collection to entries on this Date()
  model: ActivityLog,
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'log/activity',
  }),

  average: function () {
    // Return the average log count per day for this collection
    var log_sets = this.groupBy('date');
    var keys = _.keys(log_sets);
    if (!keys.length) {
      return null;
    }

    // Get the denominator
    var by_date = this.clone();
    by_date.comparator = 'date';
    by_date.sort();
    var first_date = new Date(by_date.at(0).get('date'));
    var last_date = new Date(by_date.last().get('date'));
    var day = 1000 * 60 * 60 * 24; // milliseconds in a day
    var date_span = Math.round((last_date - first_date) / day);
    // Compute the average
    var ave = _.reduce(keys, function (memo, key) {
      return memo + log_sets[key].length;
    }, 0) / (date_span + 1); // Add 1 for today
    return Math.round(ave);
  }
});


/* Activity logs of a user

An example GET request might look like this

    https://moodhacker.orcasdemo.com/api/tracker/v2/log/activity/?format=json&username=<username>&api_key=<api_key>&date__gte=2014-03-31

    Response:
    {
        "meta": {
            "limit": 0,
            "offset": 0,
            "total_count": 3
        },
        "objects": [
            {
                "activity": "/api/tracker/v2/activity/662/",
                "date": "2014-03-31",
                "id": 22366,
                "resource_uri": "/api/tracker/v2/log/activity/22366/"
            },
            {
                "activity": "/api/tracker/v2/activity/658/",
                "date": "2014-03-31",
                "id": 22371,
                "resource_uri": "/api/tracker/v2/log/activity/22371/"
            },
            {
                "activity": "/api/tracker/v2/activity/704/",
                "date": "2014-04-01",
                "id": 22372,
                "resource_uri": "/api/tracker/v2/log/activity/22372/"
            }
        ]
    }


An example POST request might look like this

    https://moodhacker.orcasdemo.com/api/tracker/v2/log/activity/?format=json&username=<username>&api_key=<api_key>

    Request body:
    {
        "activity": "/api/tracker/v2/activity/658/",
        "date": "2014-06-05"
    }

    Response:
    {
        "activity": "/api/tracker/v2/activity/658/",
        "date": "2014-06-05"
        "id": 23292,
        "resource_uri": "/api/tracker/v2/log/activity/23292/"
    }

*/



// WEBPACK FOOTER //
// ./static/js/collections/activity_log.js